import {
  LogLevel,
  NavigationClient,
  PublicClientApplication,
} from "@azure/msal-browser";

export const apiRequest = {
  scopes: [`api://${process.env.NEXT_PUBLIC_CLIENT_ID}/access_as_user`],
};

// detect safari browser TODO: commit / merge when ms authN is back up
const isSafari =
  typeof navigator !== "undefined" &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: isSafari ? "login" : "select_account",
};

// config object to be passed to msal on creation
const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_CLIENT_ID ?? "",
    authority: process.env.NEXT_PUBLIC_AUTHORITY ?? "",
    redirectUri: process.env.NEXT_PUBLIC_HOST + "/auth/bearer/return",
    postLogoutRedirectUri: process.env.NEXT_PUBLIC_HOST,
    navigateToLoginRequestUrl: true, // will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: isSafari ? "localStorage" : "sessionStorage", // configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isSafari ? true : false, // set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export class CustomNavigationClient extends NavigationClient {
  router: any;
  constructor(router: any) {
    super();
    this.router = router;
  }

  /**
   * Navigates to other pages within the same web application
   * You can use the useRouter hook provided by next.js to take advantage of client-side routing
   * @param url
   * @param options
   */
  async navigateInternal(url: string, options: { noHistory: any }) {
    const relativePath = url.replace(window.location.origin, "");
    if (options.noHistory) {
      this.router.replace(relativePath.replace("/account-utilities", ""));
    } else {
      this.router.push(relativePath.replace("/account-utilities", ""));
    }

    return false;
  }
}
